import { fetchApi } from 'utils/request';

export const apiListNotification = ({
  sessionToken,
  userId,
  params = { unread_only: true },
}: {
  sessionToken?: string;
  userId: string;
  params?: { unread_only?: boolean };
}): Promise<CF.API.Notifications.IListNotification> =>
  fetchApi({
    path: `/api/_api/v2/users/${userId}/notifications?${new URLSearchParams(params as Record<string, string>).toString()}`,
    sessionToken,
    method: 'GET',
  });

export const apiMarkNotificationsAsRead = ({
  sessionToken,
  userId,
  notifications,
}: {
  sessionToken?: string;
  userId: string;
  notifications: Pick<CF.API.Notifications.NotificationEntity, 'id' | 'is_read'>[];
}): Promise<CF.API.Notifications.IMarkNotificationAsRead> =>
  fetchApi({
    path: `/api/_api/v2/users/${userId}/notifications`,
    sessionToken,
    method: 'PATCH',
    body: {
      notifications,
      action: 'merge',
    },
  });

export const apiFetchNotificationById = ({
  sessionToken,
  userId,
  notificationId,
}: {
  sessionToken?: string;
  userId: string;
  notificationId: string;
}): Promise<CF.API.Notifications.IListNotification> =>
  fetchApi({
    path: `/api/_api/v2/users/${userId}/notifications/${notificationId}`,
    sessionToken,
    method: 'GET',
  });

export const apiDeleteNotifications = ({
  sessionToken,
  userId,
  notificationIds,
}: {
  sessionToken?: string;
  userId: string;
  notificationIds: string[];
}): Promise<CF.API.Notifications.IListNotification> =>
  fetchApi({
    path: `/api/_api/v2/users/${userId}/notifications`,
    sessionToken,
    method: 'DELETE',
    body: {
      notification_ids: notificationIds,
    },
  });
